module.exports = __webpack_public_path__ + "img/icon5.64df1ef2.png";